var exports = {
  "Tc": "PersonaTag.module__tag___c2ZBak",
  "Qq": "PersonaTag.module__text___c2ZBak",
  "Kk": "PersonaTag.module__icon___c2ZBak",
  "PW": "PersonaTag.module__standaloneIcon___c2ZBak",
};

module.exports = exports;
